import { render, staticRenderFns } from "./ChainPage.vue?vue&type=template&id=1bd80a14&scoped=true&"
import script from "./ChainPage.vue?vue&type=script&lang=ts&"
export * from "./ChainPage.vue?vue&type=script&lang=ts&"
import style0 from "./ChainPage.vue?vue&type=style&index=0&id=1bd80a14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd80a14",
  null
  
)

export default component.exports